if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.setupStickyBarObserver();
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setupStickyBarObserver() {
        console.log('[StickyBar] setupStickyBarObserver initialized for:', this);
        const stickyBarItem = this.querySelector('.sticky-bar_item');
        console.log('[StickyBar] stickyBarItem found:', stickyBarItem);
        if (!stickyBarItem) return;

        // Create a wrapper to act as our sentinel. This stays in the DOM flow.
        const wrapper = document.createElement('div');
        wrapper.classList.add('sticky-bar-wrapper');
        stickyBarItem.parentNode.insertBefore(wrapper, stickyBarItem);
        wrapper.appendChild(stickyBarItem);

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            console.log(`[StickyBar] IO entry: isIntersecting=${entry.isIntersecting}, bottom=${entry.boundingClientRect.bottom}`);
            // Trigger when wrapper is completely out of viewport (plus 50px buffer)
            if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
              if (!stickyBarItem.classList.contains('active')) {
                console.log('[StickyBar] Scrolled past wrapper. Adding active class.');
                
                // Lock the wrapper's height before it becomes position: fixed to prevent content jumping
                wrapper.style.height = `${wrapper.offsetHeight}px`;
                
                stickyBarItem.classList.add('active');
              }
            } else {
              if (stickyBarItem.classList.contains('active')) {
                console.log('[StickyBar] Wrapper in view. Removing active class.');
                stickyBarItem.classList.remove('active');
                
                // Remove fixed height so it returns to auto
                wrapper.style.height = '';
              }
            }
          });
        }, {
          // 50px buffer outside the top of the viewport
          rootMargin: '50px 0px 0px 0px'
        });
        observer.observe(wrapper);
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}
document.addEventListener("DOMContentLoaded", function () {  
  const shop_locale = document.documentElement.lang;
  function adjustCTAMargin() {
    const wrappers = document.querySelectorAll('.ws--main-slider-and-pagination-wrapper');

    wrappers.forEach(wrapper => {
      const pagination = wrapper.querySelector('.swiper-pagination');
      const ctaWrappers = wrapper.querySelectorAll('.ws-product-box-and-cta-wrapper');

      if (pagination && ctaWrappers.length > 0) {
        const paginationWidth = pagination.getBoundingClientRect().width;
        
        if (paginationWidth > 0) {
          ctaWrappers.forEach(cta => {
            if (shop_locale == 'ar'){
              cta.style.marginLeft = `${paginationWidth + 8}px`;
            } else cta.style.marginRight = `${paginationWidth + 8}px`;
          });
        }
      }
    });
  }

  const swiper = new Swiper('.ws--main-slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    on: {
      init: function () {
        adjustCTAMargin();
      },
      resize: function () {
        adjustCTAMargin();
      }
    }
  });

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(adjustCTAMargin, 150);
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const accordion = document.querySelector('details.product-details-accordian');
  if (!accordion) return;

  const mediaQuery = window.matchMedia('(max-width: 990px)');

  function handleMobileChange(e) {
    if (e.matches && accordion.hasAttribute('open')) {
      accordion.removeAttribute('open');
    }
  }
  handleMobileChange(mediaQuery);
  mediaQuery.addEventListener('change', handleMobileChange);
});